module.exports = __webpack_public_path__ + "static/media/Interrias.bfae7cfc.png";